import { useOne } from '@refinedev/core';

export const useCheckAwbService = () => {
  function check(awbNumber: string) {
    // TODO: React Hook is called in function
    return useOne<ShipmentDetail>({
      resource: 'awbs/detail',
      id: awbNumber,
    });
  }

  return {
    check,
  };
};

export default useCheckAwbService;
